import { Tooltip } from "primereact/tooltip";
import DuracaoIcon from "@/assets/icons/revisao-duracao.svg?react";
import { actionTooltipProps } from "@/ds";
import { REVISAO } from "../../../nova-obra.constants";
import { InfoLimitesClasse } from "../../../components/info-limites-classe";
import { LimitesClasseDialog } from "../../../components/limites-classe-dialog";
import styles from "../../etapa-revisao.module.scss";
import { Campo } from "../campo";
import { Secao } from "../secao";
import { LinhaDoTempo } from "./components/linha-do-tempo";
import type { SecaoDuracaoProps, SecaoDuracaoViewModel } from "./types-secao-duracao";

export function SecaoDuracaoView(props: SecaoDuracaoProps & SecaoDuracaoViewModel) {
  const {
    embarcacaoId,
    periodos,
    informacoes,
    verLimites,
    abrirLimites,
    fecharLimites,
    dados,
    cronograma,
    periodoWizard,
    onEditar,
    inicioFormatado,
    terminoPrevistoFormatado,
    duracaoTotalFormatada,
  } = props;

  return (
    <Secao id="duracao" Icone={DuracaoIcon} titulo={REVISAO.secoes.duracao} onEditar={onEditar}>
      <div className={styles.grupo}>
        <h4 className={styles.subtitulo}>{REVISAO.duracao.datasObra}</h4>
        <div className={styles.linha}>
          <Campo rotulo={REVISAO.duracao.inicioObra} valor={inicioFormatado} />
          <Campo rotulo={REVISAO.duracao.terminoPrevisto} valor={terminoPrevistoFormatado} />
          <Campo
            rotulo={REVISAO.duracao.duracaoTotal}
            valor={duracaoTotalFormatada}
            className={styles.campoDuracaoTotal}
          />
          {/* Figma 12401:175069: tooltip escuro ao passar sobre a Duração total. */}
          <Tooltip
            target={`.${styles.campoDuracaoTotal}`}
            {...actionTooltipProps(REVISAO.duracao.duracaoTotalTooltip, {
              event: "hover",
              className: styles.tooltip,
            })}
          />
        </div>
      </div>
      {informacoes.status === "success" && informacoes.data && (
        <InfoLimitesClasse
          info={informacoes.data}
          dados={dados}
          cronograma={cronograma}
          catalogo={periodos.data}
          onVerTodos={abrirLimites}
        />
      )}
      {verLimites && embarcacaoId && (
        <LimitesClasseDialog
          embarcacaoId={embarcacaoId}
          periodo={periodoWizard}
          onClose={fecharLimites}
        />
      )}
      <LinhaDoTempo />
    </Secao>
  );
}
